import type { SVGProps } from 'react';
const SvgAiMagic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.594 5.958a.4.4 0 0 0-.26.375c0 .167.104.316.26.375l1.962.736.736 1.962a.402.402 0 0 0 .75 0l.736-1.962 1.962-.736a.4.4 0 0 0 .26-.375.4.4 0 0 0-.26-.375l-1.962-.736-.736-1.962a.402.402 0 0 0-.75 0l-.736 1.962zM8.83 11.351l.837-1.81.837 1.81c.166.36.454.649.815.816l1.81.837-1.81.836c-.36.167-.649.455-.816.816l-.836 1.81-.837-1.81a1.67 1.67 0 0 0-.816-.816L6.204 13l1.813-.837c.361-.167.65-.455.816-.816zm-.08-3.799-1.43 3.1-3.101 1.431-.021.01q-.204.096-.875.403a.553.553 0 0 0 0 1.008c.448.204.736.34.875.402l.02.01 3.101 1.431 1.431 3.1.01.022q.095.203.403.875a.553.553 0 0 0 1.007 0c.5-1.08.524-1.136 1.844-3.993l3.1-1.43.021-.011.875-.403a.553.553 0 0 0 0-1.007c-1.08-.5-1.135-.524-3.993-1.844l-1.43-3.1-.01-.021q-.095-.203-.403-.875a.553.553 0 0 0-1.007 0c-.48 1.034-.4.868-.414.896zm8.694 11.004-1.961.736a.4.4 0 0 0-.26.375c0 .166.103.316.26.375l1.961.736.737 1.962c.059.156.208.26.375.26a.4.4 0 0 0 .375-.26l.736-1.962 1.961-.736a.4.4 0 0 0 .26-.375.4.4 0 0 0-.26-.375l-1.961-.736-.736-1.962a.4.4 0 0 0-.375-.26.4.4 0 0 0-.375.26z"
    />
  </svg>
);
export default SvgAiMagic;
